// extracted by mini-css-extract-plugin
export default {"container":"AboutYourselfStepContent_container__EQO6i","scrollableContent":"AboutYourselfStepContent_scrollableContent__Pz15C"};